// summary.js
import { agingCounts } from './biomarker-aging';
import { cardioCounts } from './biomarker-cardio';
import { environCounts } from './biomarker-environ';
import { hormonalCounts } from './biomarker-hormonal';
import { metabolicCounts } from './biomarker-metabolic';
import { neuroCounts } from './biomarker-neuro';

export const summarizeCounts = () => {
    const counts = [
        agingCounts,
        cardioCounts,
        environCounts,
        hormonalCounts,
        metabolicCounts,
        neuroCounts,
      ];

    const totalSummary = counts.reduce((acc, count) => {
      acc.totalMarkers += count.totalMarkers;
      acc.notMeasured += count.notMeasured;
      acc.redFlags += count.redFlags;
      acc.greenCount += count.greenCount;
      acc.targetRange += count.targetRange;
      return acc;
    }, {
      totalMarkers: 0,
      notMeasured: 0,
      redFlags: 0,
      greenCount: 0,
      targetRange: 0,
    });
    console.log("Total count summary", totalSummary);
  
    return totalSummary;
  };
  
  // If you want to keep the console log for testing, you can keep this part
  if (require.main === module) {
    const totalCounts = summarizeCounts();
    console.log('Total Biomarkers Summary:', totalCounts);
  }